import React from 'react'

// ReactorUi
import { Box, Flex } from 'reactor-ui'
import * as RV from 'reactor-vera/templates/v1'
import * as Settings from 'reactor-vera/templates/v1/Settings'


const IntegrationSettings = props => {
  return (
    <>
    <MernisIntegrationSettings/>
    </>
  )
}

const MernisIntegrationSettings = props => {
  const result = RV.useReactorResource('prBase.settings.settings', { name: 'MernisSettings' })
  return (
    <RV.QueryLoading result={result}>
      {() => (
        <>
          <Settings.SettingsCard name={result.data.name} description={result.data.ui?.description}>
            <Settings.SettingsForm result={result} />
          </Settings.SettingsCard>
        </>
      )}
    </RV.QueryLoading>
  )
}

export default IntegrationSettings